/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp5 } from './commonProp5';
import { commonProp7 } from './commonProp7';
import { commonProp4 } from './commonProp4';

export const dancing_clothing : {[key: string]: Array<[string, string]>} = {
    p_sex: commonProp5,
    p_size: commonProp7,
    p_brand: [
        d("bloch"),
        d("capezio"),
        d("DanceMaster"),
        d("domyos"),
        d("dragonfly"),
        d("freed of london"),
        d("mirella"),
        d("Pridance"),
        d("Ratchet"),
        d("rumpf"),
        d("so danca"),
        d("starever"),
        d("Tech Dance"),
        ["HANDMADE", "Handmade"],
        ["OTHER_BRAND", "Jin\u00e1 zna\u010dka"],
    ],
    p_color: commonProp4,
};
